import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReportParameterFormFactoryService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form-factory.service';
import { Store } from '@ngrx/store';
import { interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardTile } from 'src/app/pages/dashboard/models/dashboard-tile.model';
import { DashboardTileColumn } from 'src/app/pages/dashboard/models/tile.model';
import { Tiles } from '../../containers//tile-wrapper/tile-component-accessor';
import { TileBase } from '../shared/tile-base';
import { QueueMembersParametersFormService } from './services/queue-members-parameters-form.service';

@Component({
   encapsulation: ViewEncapsulation.None,
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'ndt-queue-members-tile',
   styleUrls: ['./queue-members-tile.component.scss'],
   templateUrl: './queue-members-tile.component.html',
   host: {
      class: 'queue-members-table-tile-wrapper',
   },
   standalone: false,
})
export class QueueMembersTileComponent extends TileBase<QueueMembersParametersFormService, any> implements OnChanges {
   queueMembersData: any[] = [];
   private lastMembersRef: any[] | null = null;
   // columns = [
   //    'agentName',
   //    'callCount',
   //    'outboundCallCount',
   //    'overallTalkTime',
   //    'avgCallTime',
   //    'callsPerHour',
   //    'currentTime',
   //    'timeSinceLastCall',
   //    'availability',
   //    'queues',
   // ];

   columns = [
      'agentName',
      'callCount',
      'outboundCallCount',
      'overallTalkTime',
      'currentTime',
      'timeSinceLastCall',
      'availability',
      'queues',
   ];

   constructor(
      protected formServiceFactory: ReportParameterFormFactoryService,
      protected store: Store,
      public changeDetectorRef: ChangeDetectorRef,
      protected fb: UntypedFormBuilder,
      protected router: Router
   ) {
      super(formServiceFactory, store, changeDetectorRef, fb, router);
      this.formService = formServiceFactory.getService(Tiles.QueueMembers);

      interval(100)
         .pipe(takeUntil(this.destroyed$))
         .subscribe(() => {
            this.refresh();
            this.changeDetectorRef.markForCheck();
         });
   }

   ngOnChanges(): void {
      this.refresh();
   }

   onRefreshTile() {
      this.refresh();
      this.changeDetectorRef.markForCheck();
   }

   getRouterLink(memberId: number): string {
      return `/extensions/${memberId}`;
   }

   get rowHeight(): number {
      return this.getTileTableRowHeight(this.tileConfig);
   }
   get columnSort() {
      const value = this.tileConfig?.dashboardTileParameters?.find((p) => p.parameterType === 'ColumnSort')?.value;

      if (!value) {
         return null;
      }

      const [column, direction] = value.split(':');

      return { column, direction };
   }
   getSortDirection(column: string): string | null {
      return this.columnSort?.column?.toLowerCase() === column.toLowerCase() ? this.columnSort.direction : null;
   }
   getSort(column: string): string {
      switch (this.getSortDirection(column)) {
         case 'Asc':
            return 'arrow_upward';
         case 'Desc':
            return 'arrow_downward';
         default:
            return '';
      }
   }
   private refresh(): void {
      const members = this.tileData?.data?.members ?? [];
      // Reset the elapsed counter only when the data reference changes (new fetch)
      if (this.lastMembersRef !== members) {
         this.lastMembersRef = members;
      }
      this.queueMembersData = members;
   }

   getTileTableRowHeight(tileConfig: DashboardTile | null): number {
      return (tileConfig?.dashboardTileLayoutConfiguration?.height ?? -1) <= 1 ? 25 : 35;
   }
}

export const QueueMembersTileColumns: DashboardTileColumn[] = [
   {
      name: 'AgentName',
      displayName: 'Agent',
   },
   {
      name: 'CallCount',
      displayName: 'Call Count',
   },
   {
      name: 'OutboundCallCount',
      displayName: 'Outbound',
   },
   {
      name: 'OverallTalkTime',
      displayName: 'Talk Time',
   },
   {
      name: 'CurrentTime',
      displayName: 'Current Time',
   },
   {
      name: 'TimeSinceLastCall',
      displayName: 'Time Since',
   },
   {
      name: 'Availability',
      displayName: 'Status',
   },
   {
      name: 'Queues',
      displayName: 'Queues',
   },
];
